import KT01BaseLayout from "general/components/BaseLayout/KT01BaseLayout";
import { Route, Routes } from "react-router-dom";
import CoinvestorReconciliationListScreen from "./screens/CoinvestorReconciliationListScreen";
import CoinvestorReconciliationDetailScreen from "./screens/CoinvestorReconciliationDetailScreen";

function CoinvestorReconciliationReport(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route
                        path=""
                        element={
                            <CoinvestorReconciliationListScreen />
                        }
                    />
                    <Route path="/:reconciliationId" element={<CoinvestorReconciliationDetailScreen />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default CoinvestorReconciliationReport;
